
      // Only load the game if not on mobile
      if (!window.__blockGameLoad) {
        import('/src/main.ts');
      }
    